import React from 'react';

import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';
import Main from "./components/Main";
import PayPlans from './components/PayPlans';
import FormPrice from './components/FormPrice';

const App = () => {

  return (
    <Router>
      <Switch>
        <Route path='/index' children={<Main/>} />
        <Route path="/Payplans" component={PayPlans} />
        <Route path="/FormPrice" component={FormPrice} />
        <Route path='*'>
          <Redirect to='/index'/>
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
